export { createCloseEvent, Dialog } from '../dialog';
export type { TDialogCloseReason, TDialogDismissedBy, TDialogProps } from '../dialog';
